import { render, staticRenderFns } from "./ImagesCard.vue?vue&type=template&id=73be0795"
import script from "./ImagesCard.vue?vue&type=script&lang=js"
export * from "./ImagesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports